// extracted by mini-css-extract-plugin
export default {"copybutton":"copybutton_fda86441a4a6f792ac91","copier":"copier_b346757645aebafb002b","sign":"sign_a4d5ebd60079ef98e3fd"};